import CanvasObject from "./CanvasObject";

export default class ControlPoint {
  constructor(editor, x, y, kf, options) {
    this.keyframe = kf;
    this.editor = editor;
    this.x = x;
    this.y = y;
    this.points = [];
    this.options = options;
    this.input = null;
    this.init();
  }

  init() {
    const editor = this.editor;
    const x = this.x;
    const y = this.y;
    if (this.options) {

      const CPOptions = this.options.controlPoint;

      const Point = new CanvasObject(editor.getCanvas(), {
          x: x,
          y: y,
          draggable: false,
          type: 'circle',
          constraints: {
            minY: 0,
            maxY: editor.height,
            axis: 'y',
            doSnap: true,
            snap: {
              gridPoints: [{x: 50 + x, y: 100}, {x: 50 + x, y: 600}],
              colSpace: 0,
              rowSpace: 500
            },
            snapFree: false
          }
        }, {fill: '#F25858', stroke: '#F25858 2', radius: 5});

      const CP = new CanvasObject(editor.getCanvas(), {x: CPOptions.x, y: CPOptions.y, draggable: true, type: 'circle', constraints: {
        maxX: editor.width + 50,
        maxY: editor.height + 50,
        minX: -50,
        minY: -50,
        snap: editor.grid,
        snapFree: true
      }}, {fill: 'white', stroke: '#479AF9 1', radius: 6});

      const ControlOBJ = {
        curvePoint: Point,
        controlPoints: [CP]
      };

      Point.on('focus', (e) => {
        if(editor.isHidden(CP))
          editor.show(CP)
      })

      Point.on('unfocus', (e, obj) => {
        if(!editor.isHidden(CP) && (obj !== CP))
          editor.hide(CP);
      });

      Point.on("move", e => {
        const eFrom = e.from;
        const eTo = e.to;
        const diff = {
          y: eTo.y - eFrom.y
        };
        CP.y += diff.y;

        if(this.input) {
          this.input.y += diff.y;
        }

        if(Math.abs(diff.y) > 0) {
          this.input.updateValue(editor.controls.indexOf(ControlOBJ) === 0 ? editor.keyframes[0].value : editor.keyframes[editor.keyframes.length - 1].value);
          editor.updateStartAndEnd(Point);
        }
      });

      Point.on('updatePos', e => {
        const eFrom = e.from;
        const eTo = e.to;
        const diff = {
          y: eTo.y - eFrom.y
        };

        CP.y += diff.y;

        if(this.input) {
          this.input.y += diff.y;
          this.input.updateValue(editor.controls.indexOf(ControlOBJ) === 0 ? editor.keyframes[0].value : editor.keyframes[editor.keyframes.length - 1].value);
        }
      });

      [Point, CP].forEach(p => p.on('move', (e) => {
        editor.updateKeyframes();
        editor.preview();
      }));

      editor.hiddenObjects.push(CP);

      this.points.push(Point, CP);
      this.control = ControlOBJ;

    } else {
      const newCP = new CanvasObject(editor.getCanvas(), {
        x,
        y,
        draggable: true,
        type: "circle",
        constraints: {
          maxX: editor.width + 50,
          maxY: editor.height + 50,
          minX: -50,
          minY: -50,
          doSnap: true,
          snap: editor.grid,
          snapFree: true
        }
      }, {
        fill: "white",
        stroke: "#479AF9 1.5",
        radius: 5
      });

      //F25858

      const CP1 = new CanvasObject(editor.getCanvas(), {
        x,
        y,
        draggable: true,
        type: "circle",
        constraints: {
          maxX: editor.width + 50,
          maxY: editor.height + 50,
          minX: -50,
          minY: -50,
          doSnap: true,
          snap: editor.grid,
          snapFree: true
        }
      }, {
        fill: "white",
        stroke: "#479AF9 1.5",
        radius: 6
      });

      const CP2 = new CanvasObject(editor.getCanvas(), {
        x,
        y,
        draggable: true,
        type: "circle",
        constraints: {
          maxX: editor.width + 50,
          maxY: editor.height + 50,
          minX: -50,
          minY: -50,
          doSnap: true,
          snap: editor.grid,
          snapFree: true
        }
      }, {
        fill: "white",
        stroke: "#479AF9 1.5",
        radius: 6
      });

      const newCPObj = {
        curvePoint: newCP,
        controlPoints: [CP1, CP2]
      };

      newCP.on("move", e => {
        const eFrom = e.from;
        const eTo = e.to;
        const diff = {
          x: eTo.x - eFrom.x,
          y: eTo.y - eFrom.y
        };
        // console.log(diff);
        CP1.x += diff.x;
        CP2.x += diff.x;

        CP1.y += diff.y;
        CP2.y += diff.y;

        this.keyframe.x = eTo.x;
        const duration = editor.animationDuration;
        // const startTime = editor.startTime;

        const updatedTime = (eTo.x - editor.customs.padding.left) / editor.width * duration;

        editor.updateKeyframe(this.keyframe.time, updatedTime);
        this.keyframe.updateTime(updatedTime)
      });

      newCP.on("dbclick", e => {
        e.preventDefault();
        if (editor.isHidden(CP1)) {
          CP1.x -= 100;
          CP2.x += 100;
          editor.show(CP1, CP2);
        } else {
          CP1.x = newCP.x;
          CP2.x = newCP.x;
          CP1.y = newCP.y;
          CP2.y = newCP.y;
          editor.hide(CP1, CP2);
        }
      });

      newCP.on('mouseup', (e) => {
        // Update the state
        editor.updatePoints();
      })

      newCP.on("focus", e => {
        newCP.drawOptions.fill = '#479AF9';
        if (editor.canRemovePoint) {
          editor.remove(newCP);
          return;
        }
        if (editor.isHidden(CP1) && !(CP1.x === newCP.x && CP2.x === newCP.x && CP1.y === newCP.y && CP2.y === newCP.y))
          editor.show(CP1, CP2);
        }
      );

      newCP.on("unfocus", (e, obj) => {
        if(obj !== CP1 && obj !== CP2) newCP.drawOptions.fill = 'white';
        if (!editor.isHidden(CP1) && (obj !== CP1 && obj !== CP2))
          editor.hide(CP1, CP2);
        }
      );

      newCP.on('updatePos', e => {
        const eFrom = e.from;
        const eTo = e.to;
        const diff = {
          y: eTo.y - eFrom.y
        };

        CP1.y += diff.y;
        CP2.y += diff.y;
      });

      [newCP, CP1, CP2].forEach(p => p.on('move', (e) => {
        editor.updateKeyframes();
        editor.preview();
      }));

      editor.hiddenObjects.push(CP1, CP2);

      this.points.push(newCP, CP1, CP2);
      this.control = newCPObj;
    }

  }

  /**
   * Push the control point to the editor
   */
  push() {
    const editor = this.editor;
    const near = editor.nearestPoint(this.x, this.y);
    const nearestObj = near.obj;

    const nearestControl = editor.controls.find(el => {
      return el.curvePoint.id === nearestObj.id
    });
    const dir = near.dir;

    let indexOfNewObj = dir === 'left'
      ? editor.controls.indexOf(nearestControl) + 1
      : editor.controls.indexOf(nearestControl);

    editor.controls.splice(indexOfNewObj, 0, this.control);

    editor.addObject(...this.points, this.keyframe);
    editor.hide(this.points[1], this.points[2]);
  }

}



// WEBPACK FOOTER //
// ./src/components/canvas/objects/ControlPoint.js